// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4f25de3d","732":"1c3671fd","977":"7ba642df"}[chunkId] + ".chunk.js";
};